import '../lib/huvTicker.min'
import '../lib/jquery.tile.min'
import '../pages/index'
import '../sass/index.scss'
